import { updateObject } from "../../utility";

export const login = (
  state = {
    isLogin: false,
    token: null,
    email: null,
    isRegister: false,
  },
  action
) => {
  switch (action.type) {
    case "LOGIN_WITH_EMAIL": {
      return { ...state, values: action.payload };
    }
    case "LOGIN_WITH_FB": {
      return { ...state, values: action.payload };
    }
    case "LOGIN_WITH_TWITTER": {
      return { ...state, values: action.payload };
    }
    case "LOGIN_WITH_GOOGLE": {
      return { ...state, values: action.payload };
    }
    case "LOGIN_GOOGLE": {
      return { ...state, values: action.payload };
    }
    case "LOGIN_WITH_GITHUB": {
      return { ...state, values: action.payload };
    }
    case "LOGIN_WITH_JWT": {
      return updateObject(state, action.payload);
    }
    case "LOGIN_WITH_FR": {
      return { ...state, values: action.payload };
    }
    case "LOGOUT_WITH_JWT": {
      return { ...state, values: action.payload };
    }
    case "LOGOUT_WITH_FIREBASE": {
      return { ...state, values: action.payload };
    }
    case "CHANGE_STATUS": {
      return {
        ...state,
        isLogin: action.isLogin,
        isRegister: action.isRegister,
      };
    }
    case "SET_TOKEN": {
      return { ...state, token: action.token };
    }
    case "SET_EMAIL": {
      return { ...state, email: action.email };
    }
    default: {
      return state;
    }
  }
};
